import React, { useRef, useState } from 'react';
import { SearchOutlined } from '@ant-design/icons';
import { Button, Input, Space, Table ,Modal} from 'antd';
import Highlighter from 'react-highlight-words';
 import { useEffect } from 'react';
import ArticleModal from './ArticleModal';
import '../css/ArticleTable.css';
import { ArticlesContext } from 'contexts/ArticlesContext';
import { useContext } from 'react';

const ArticleTable = ({ articles}) => {
  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const[type,setType] =useState('');
  const[articleId,setArticleId]=useState('') ;
  const [modalVisible, setModalVisible] = useState(false);
  const searchInput = useRef(null);
  const [loading, setLoading] = useState(false);
  const { page, setPage, pageSize, setPageSize, totalCount } = useContext(ArticlesContext);

  function stripHtml(html) {
    return html.replace(/<[^>]+>/g, '');
    }
    function decodeHtml(html) {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }
  
  const handleTableChange = (pagination) => {
    setPage(pagination.current);
    setPageSize(pagination.pageSize);
  };

  useEffect(() => {
  setLoading(true);
  const timeout = setTimeout(() => {
    setLoading(false);
  }, 500); // مثلا ۰.۵ ثانیه بعد از دریافت props نمایش لودینگ رو قطع کن

  return () => clearTimeout(timeout);
  }, [articles]);

  const data = articles.map((article, i) => ({
    key: String(i + 1), // تبدیل اندیس به رشته برای key
    title: article.title ? stripHtml(decodeHtml(article.title)) : '',
    author: article.author || '',
    history: '',
    date: article.createdDate ? article.createdDate.split("T")[0] : '', // نمایش فقط تاریخ
    id: article.id || '' ,
    journal: article.journalTitle ,
    code : article.code ,
  }));

  const handleRowClick = (record) => {
    setArticleId(record.id);
    setType("articleDetails");
    setModalVisible(true);

  };


  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{ width: 90 }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({ closeDropdown: false });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
          <Button type="link" size="small" onClick={() => close()}>
            Close
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />,
    onFilter: (value, record) =>
      record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: {
      onOpenChange(open) {
        if (open) {
          setTimeout(() => searchInput.current?.select(), 100);
        }
      },
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });

  const handleViewClick = (event,record) => {
    event.stopPropagation(); // جلوگیری از اجرای onRow
      setArticleId(record.id);
      setType("articleHistory");
      setModalVisible(true);
  };

  const handleCloseModal = () => {
    setModalVisible(false);
    setType(null);
    setArticleId(null) ;
  };

  const columns = [
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      width: '20%',
      ...getColumnSearchProps('code'),
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      width: '50%',
      ...getColumnSearchProps('title'),
    },
    {
      title: 'Author',
      dataIndex: 'author',
      key: 'author',
      width: '20%',
      ...getColumnSearchProps('author'),
      align: 'center',

    },
    {
      title: 'Journal',
      dataIndex: 'journal',
      key: 'journal',
      width: '20%',
      ...getColumnSearchProps('journal'),
      align: 'center',

    },
    {
      title: 'Date',
      dataIndex: 'date',
      key: 'date',
      width: '10%',
      sorter: (a, b) => new Date(a.date) - new Date(b.date),
      sortDirections: ['descend', 'ascend'],
      align: 'center',

    },
    {
      title: 'History',
      dataIndex: 'history',
      key: 'history',
      width: '10%',
      align: 'center',
      render: (_, record) => (
        <Button type="link" onClick={(event) => handleViewClick(event, record)}>View History</Button>
      )
    },
  ];
  return (
    <>
      {/* <Table 
        columns={columns} 
        dataSource={data} 
        rowKey="id" 
        onRow={(record) => ({
          onClick: () => handleRowClick(record), 
          style: { cursor: 'pointer' }, 
        })} 
        rowClassName={() => 'custom-row-hover'} 
      /> */}
      <Table 
        columns={columns} 
        dataSource={data} 
        rowKey="id" 
        loading={loading}
        onRow={(record) => ({
          onClick: () => handleRowClick(record), 
          style: { cursor: 'pointer' }, 
        })} 
        rowClassName={() => 'custom-row-hover'} 
        pagination={{
          current: page,
          pageSize: pageSize,
          total: totalCount,
          showSizeChanger: true,
          pageSizeOptions: ['10', '20', '50', '100'],
          showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} articles`,
        }}
        onChange={handleTableChange}
      />
       <Modal

        title={type === "articleHistory" ? "Article History" : "Article Details"}        
        open={modalVisible}
        onCancel={handleCloseModal}
        footer={null}
        width="80%" // عرض مودال
        centered 
        bodyStyle={{ maxHeight: "70vh", overflowY: "auto" }} // محدود کردن ارتفاع و فعال کردن اسکرول
        >
        <ArticleModal articleId={articleId} type={type} />
      </Modal>      

    </>
  );


};

export default ArticleTable;
